export default "<p>reading-english-type works!</p>\n"